document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-mt-product-countdown').forEach((root) => {
    const endRaw = (root.getAttribute('data-end') || '').trim();
    const timeEl = root.querySelector('.js-mt-pcdown-time');
    if (!timeEl) return;

    const parseEnd = (s) => {
      if (!s) return null;
      // Accept ISO or "YYYY-MM-DD HH:MM:SS"
      const iso = s.includes('T') ? s : s.replace(' ', 'T');
      const d = new Date(iso);
      if (!isNaN(d.getTime())) return d;
      return null;
    };

    const end = parseEnd(endRaw);
    if (!end) return;

    const pad2 = (n) => String(Math.max(0, n)).padStart(2, '0');
    const partHtml = (value, label) => {
      return [
        `<span class="mt-product-countdown__time-part">`,
        `  <span class="mt-product-countdown__time-num">${pad2(value)}</span>`,
        `  <span class="mt-product-countdown__time-label">${label}</span>`,
        `</span>`
      ].join('');
    };
    const renderTime = (days, hrs, mins, secs) => {
      timeEl.innerHTML = [
        partHtml(days, 'Days'),
        `<span class="mt-product-countdown__time-sep">:</span>`,
        partHtml(hrs, 'Hours'),
        `<span class="mt-product-countdown__time-sep">:</span>`,
        partHtml(mins, 'Mins'),
        `<span class="mt-product-countdown__time-sep">:</span>`,
        partHtml(secs, 'Secs')
      ].join('');
    };

    const tick = () => {
      const now = Date.now();
      let diff = end.getTime() - now;
      if (diff < 0) diff = 0;

      const sec = Math.floor(diff / 1000);
      const days = Math.floor(sec / 86400);
      const hrs = Math.floor((sec % 86400) / 3600);
      const mins = Math.floor((sec % 3600) / 60);
      const secs = sec % 60;

      renderTime(days, hrs, mins, secs);
      if (diff === 0) {
        root.classList.add('is-ended');
      } else {
        root.classList.remove('is-ended');
      }
    };

    tick();
    const id = setInterval(tick, 1000);
    root.addEventListener('shopify:section:unload', () => clearInterval(id));
  });
});

